import React, {useRef, useState} from "react";
import styled from "styled-components";
import {RTEWrapper} from "BaseComponents/Wrappers";
import {H3} from "../../BaseComponents/Text";

export const FAQItem = ({Question, Answer, lastItem}) => {
    const [open, setOpen] = useState(false);
    let answerRef = useRef();

    const handleClick = () => {
        setOpen(!open);
        const {current} = answerRef;
        current.style.height = !open ? current.scrollHeight + "px" : 0;
    };
    return (
        <Item lastItem={lastItem} open={open}>
            <QuestionButton open={open} onClick={handleClick}>
                <Heading>{Question}</Heading>
                <Icon open={open}></Icon>
            </QuestionButton>
            <Child ref={answerRef} show={open}>
                <ChildWrapper dangerouslySetInnerHTML={{__html: Answer}}></ChildWrapper>
            </Child>
        </Item>
    );
};

const ChildWrapper = styled(RTEWrapper)`
    padding: 1rem 1.25rem 1.75rem 1.25rem;
`;
const QuestionButton = styled.button.attrs(({open, ariaLabel}) => ({
    "aria-expanded": open ? "true" : "false",
    "aria-label": ariaLabel || "toggle button",
}))`
    border-top: ${({theme}) => `2px solid ${theme.colors.grey}`};
    color: ${({theme}) => theme.colors.primary};
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    position: relative;
    width: 100%;
    border: none;
    line-height: 1.4;
    background-color: unset;
    display: flex;
    align-items: center;
    width: 100%;
    transition: all 0.2s ease 0s;
    outline: 0px;
    padding: 1rem;
`;
const Child = styled.div.attrs(({show}) => ({
    "aria-hidden": show ? "false" : "true",
}))`
    opacity: ${({show}) => (show ? 1 : 0)};
    overflow: hidden;
    transition: 0.2s ease-out;
    height: 0;
    color: black;
`;

const Heading = styled(H3)`
    flex-basis: 90%;

    & {
        font-size: 18px;
    }
`;
const Icon = styled.i`
    position: absolute;
    right: 15px;
    font-size: 20px;
    top: 3%;
    flex-basis: 10%;

    &:before {
        content: "";
        position: absolute;
        top: 22px;
        left: calc(100% - 28px);
        height: 11px;
        width: 2px;
        border-radius: 0;
        background-color: ${({theme}) => theme.colors.primary};
        transform: ${({open}) => (open ? "rotate(45deg)" : "rotate(135deg)")};
        transition: transform 0.2s ease-in;
    }

    &:after {
        content: "";
        position: absolute;
        top: 22px;
        left: calc(100% - 21px);
        height: 11px;
        width: 2px;
        border-radius: 0;
        background-color: ${({theme}) => theme.colors.primary};
        transform: ${({open}) => (open ? "rotate(-45deg)" : "rotate(-135deg)")};
        transition: transform 0.2s ease-in, left 0.2s ease-in;
    }

    transition: transform 0.5s ease;
`;
const Item = styled.div`
    background-color: ${({open, theme}) => (open ? theme.colors.bg1 : "")};
    border-top: ${({theme}) => `2px solid ${theme.colors.grey}`};
    transition: 0.2s ease;
    vertical-align: top;
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    width: 100%;

    &:hover {
        transition: 0.2s ease;
        background-color: ${({theme}) => theme.colors.bg1};
    }

    border-bottom: ${({theme, lastItem}) => (lastItem ? `2px solid ${theme.colors.grey}` : "")};
`;
